import { navigate } from '@reach/router';
import { Button } from 'components/button/Button';
import React from 'react';
import Icon_Warning from '../../assets/apply.clevry/Icon_Warning.png';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

type SentryFallbackProps = {
  error?: unknown;
  componentStack?: string | null;
  eventId?: string;
  resetError?: () => void;
}


const ErrorFallback = ({resetError}: SentryFallbackProps) => {
  const { t } = useTranslation('Error+Fallback', { i18n });

  return (
    <div className="ErrorPage">
      <div className="ErrorCell">
        <div className="Img">
          <img
            src={Icon_Warning}
            alt={t('SSCandidate_Error_Fallback_Alt_Error')}
          />
        </div>
        <div className="Txt">
          <h1>
             {t('SSCandidate_Error_Fallback_Something_Went_Wrong')}
          </h1>
          <p>{t('SSCandidate_Error_Fallback_Try_Again')}</p>
        </div>
        <Button
          priority={'primary'}
          onClick={() => navigate('/home')}
        >
          {t('SSCandidate_Error_Fallback_Return_Home')}
        </Button>
        <Button
          priority={'secondary'}
          onClick={resetError}
        >
          Retry
        </Button>
      </div>
    </div>
  );
};

export default ErrorFallback;
